// extracted by mini-css-extract-plugin
export default {"socialIcons":"SocialSection_socialIcons__8FsGB","light":"SocialSection_light__G+GP4"};